import { ClockAfternoonIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Clock = (props: IconProps) => {
  const { size = 'md', ...rest } = props;

  return <ClockAfternoonIcon {...rest} size={Sizes[size]} />;
};

Clock.displayName = 'Clock';
